import { render } from "./XlsxModelView.vue?vue&type=template&id=07dd845a"
import script from "./XlsxModelView.vue?vue&type=script&lang=ts"
export * from "./XlsxModelView.vue?vue&type=script&lang=ts"
script.render = render

export default script